import React from 'react';

export default () => (
  <svg
    width="34px"
    viewBox="0 0 50 66"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Bottomline Technologies</title>
    <g id="Styleguide" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Group-8" fill="#FFFFFF">
        <path d="M41.0059 20.9809C40.8465 29.0471 41.2563 35.411 38.236 38.229C35.418 41.2493 29.0548 40.8388 20.9879 40.999C12.9217 40.8381 6.55856 41.2493 3.73976 38.229C0.720213 35.411 1.12925 29.0479 0.969849 20.9809C1.13075 12.9148 0.718709 6.55162 3.73976 3.73282C6.55781 0.712521 12.921 1.12304 20.9879 0.962891C29.0548 1.12379 35.4172 0.712521 38.2353 3.73282C41.2563 6.55087 40.845 12.9148 41.0052 20.9809H41.0059Z" fill="#0070B9" />
        <path d="M31.2713 21.311C31.2713 19.1891 30.139 17.332 28.445 16.311C29.1683 15.4937 29.6074 14.4192 29.6074 13.2418C29.6074 10.6816 27.5322 8.60645 24.9721 8.60645H12.4172V27.1471H25.436C28.6586 27.1471 31.2713 24.5343 31.2713 21.3117V21.311ZM15.7774 11.3343H24.1127C25.3119 11.3343 26.2849 12.3065 26.2849 13.5065C26.2849 14.7065 25.3127 15.6786 24.1127 15.6786H15.7774V11.335V11.3343ZM15.7774 23.8065V18.7846H25.3525C26.739 18.7846 27.8638 19.9087 27.8638 21.2959C27.8638 22.6831 26.7398 23.8065 25.3525 23.8065H15.7774ZM29.4089 30.2463H13.6864C12.8277 30.2463 12.1315 30.9425 12.1315 31.8012C12.1315 32.6598 12.8277 33.3561 13.6864 33.3561H29.4751C30.3841 33.3561 31.1112 32.5764 31.0224 31.6485C30.9458 30.8403 30.2202 30.2463 29.4082 30.2463H29.4089Z" fill="white" />
      </g>
    </g>
  </svg>
);
